import { useTranslations } from "next-intl";
import { useEffect, useRef } from "react";
import classNames from "classnames";
import {
  useUserListsManager,
  useIsAddToUserListToastOpen,
  useCloseAddedToWishlistToast,
  useOpenAddToUserListOffcanvas,
} from "@hooks/use-userlists";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import ProductImage from "@components/core/ProductImage";

function AddedToWishlistToast() {
  const t = useTranslations("common");

  const trackEvent = useButtonEventTracking();
  const userlistsManager = useUserListsManager();
  const { product } = userlistsManager;
  const isAddToUserListToastOpen = useIsAddToUserListToastOpen();
  const closeAddedToWishlistToast = useCloseAddedToWishlistToast();
  const openAddToUserListOffcanvas = useOpenAddToUserListOffcanvas();

  const closeTimeout = useRef(null);

  function handleClick() {
    trackEvent("AddToListFromToast");

    openAddToUserListOffcanvas(product);
  }

  useEffect(() => {
    if (isAddToUserListToastOpen) {
      closeTimeout.current = setTimeout(() => {
        closeAddedToWishlistToast();
      }, 5000);
    }

    return () => {
      if (closeTimeout.current) clearTimeout(closeTimeout.current);
    };
  }, [isAddToUserListToastOpen, closeAddedToWishlistToast]);

  return (
    <div className="userlist-toast">
      <button
        className="btn-transparent userlist-toast-container"
        onClick={handleClick}
      >
        <div className={classNames("userlist-toast-content", isAddToUserListToastOpen && "open")}>
          <div className="pe-3 d-flex align-items-center">
            <ProductImage
              src={product?.main_picture_url}
              sizes="64px"
              className="userlist-toast-image-container"
            />

            <p className="mb-0 text-white text-2-lines">{t("userlist.added_to_wishlist")}</p>
          </div>

          <div>
            <p className="text-white mb-0 userlist-toast-action text-1-line">
              {t("userlist.add_to_userlist")}
            </p>
          </div>
        </div>
      </button>
    </div>
  );
}

export default AddedToWishlistToast;
